import { useMutation } from '@tanstack/react-query';

import { axios } from '@/src/lib/axios/axios';
import { generateRoutePath } from '@/src/routes';

import { INBOX_DOCUMENT_BASE_URL } from '.';

type CreateAutomationParams = {
  inboxDocumentId: number;
};

type CreateAutomationResponse = {
  automationId: number;
};

const createAutomation = ({
  inboxDocumentId,
}: CreateAutomationParams): Promise<CreateAutomationResponse> => {
  const url = generateRoutePath(`${INBOX_DOCUMENT_BASE_URL}/:inboxDocumentId/scan`, {
    inboxDocumentId,
  });

  return axios.post(url, null, { showError: false });
};

export const useCreateAutomation = (inboxDocumentId: CreateAutomationParams) => {
  return useMutation({
    mutationFn: () => createAutomation(inboxDocumentId),
  });
};
